// extracted by mini-css-extract-plugin
export default {"body":"GradientBackground_body__ZOk6j","gradient":"GradientBackground_gradient__aZwos","circles":"GradientBackground_circles__KvIZR","animate":"GradientBackground_animate__UfqOU"};